/** localStorage keys for storefront light/dark theme */
export const DARK_MODE_STORAGE_KEY = 'sheenwear_dark_mode';
export const THEME_STORAGE_KEY = 'sheenwear_theme';

/**
 * @returns {boolean}
 */
export function readDarkModePreference() {
  try {
    const raw = localStorage.getItem(DARK_MODE_STORAGE_KEY);
    if (raw === '1' || raw === 'true') return true;
    if (raw === '0' || raw === 'false') return false;
    const theme = localStorage.getItem(THEME_STORAGE_KEY);
    if (theme === 'dark') return true;
    if (theme === 'light') return false;
  } catch {
    /* ignore */
  }
  return false;
}

/**
 * @param {boolean} enabled
 */
export function writeDarkModePreference(enabled) {
  try {
    const on = Boolean(enabled);
    localStorage.setItem(DARK_MODE_STORAGE_KEY, on ? '1' : '0');
    localStorage.setItem(THEME_STORAGE_KEY, on ? 'dark' : 'light');
  } catch {
    /* ignore */
  }
}

/**
 * Applies or removes `dark-theme` on <html> (matches global.css selectors).
 * @param {boolean} enabled
 */
export function applyDarkModeToDocument(enabled) {
  const root = document.documentElement;
  if (!root) return;
  if (enabled) {
    root.classList.add('dark-theme');
    root.style.colorScheme = 'dark';
  } else {
    root.classList.remove('dark-theme');
    root.style.colorScheme = 'light';
  }
}

/** Call before first paint to avoid flash of wrong theme */
export function initThemeFromStorage() {
  applyDarkModeToDocument(readDarkModePreference());
}
